<div class="row page-title">
  <span>{{ localizationConstants.USER_PAGE_TITLE | translate }}</span>
</div>
<div
  *ngIf="isLoading"
  class="row center">
  <div class="col">
    <app-loading-icon
      class="u-color--light"
      size="2x"></app-loading-icon>
  </div>
</div>
<form #userForm="ngForm">
  <div
    *ngIf="isMissingFromEntra"
    class="row center bg-white bg-default-sm u-shadow">
    <div class="c-user col u-mw--600 u-mt--large">
      <div class="o-grid--medium">
        <div class="o-grid__item col-12 c-form-alert u-text-left">
          <h2>{{ localizationConstants.USER_NOT_IN_ENTRA_TITLE | translate }}</h2>
          <p style="white-space: pre-line">
            {{ localizationConstants.USER_NOT_IN_ENTRA_MESSAGE | translate }}
          </p>
        </div>
        <div class="o-grid__item col-12">
          <button
            type="button"
            class="button button-secondary button-block"
            [disabled]="isSaving || isLoading"
            (click)="deleteUser()">
            <app-loading-icon *ngIf="isSaving"></app-loading-icon>
            <span *ngIf="!isSaving">{{
              localizationConstants.USER_NOT_IN_ENTRA_DELETE | translate
            }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="user"
    class="row center bg-white bg-default-sm u-shadow">
    <div class="c-user u-mt--large col u-mw--600">
      <div class="o-grid--medium u-mt--medium">
        <h2 class="o-grid__item col-12 u-text-left">
          {{ "user.maininfo" | translate }}
        </h2>
        <div class="c-form-group o-grid__item col-12 col-sm-6">
          <label
            for="firstName"
            class="c-form-label"
            >{{ "user.firstname" | translate }}</label
          >
          <input
            #firstName="ngModel"
            [(ngModel)]="user.firstName"
            name="firstName"
            id="firstName"
            type="text"
            class="c-input c-input--alpha"
            [class.is-invalid]="firstName.touched && firstName.invalid"
            required />
          <div
            *ngIf="firstName.touched && firstName.invalid"
            class="c-form-alert">
            {{ "user.firstnamerequirederror" | translate }}
          </div>
        </div>
        <div class="c-form-group o-grid__item col-12 col-sm-6">
          <label
            for="lastName"
            class="c-form-label"
            >{{ "user.lastname" | translate }}</label
          >
          <input
            #lastName="ngModel"
            [(ngModel)]="user.lastName"
            name="lastName"
            id="lastName"
            type="text"
            class="c-input c-input--alpha"
            [class.is-invalid]="lastName.touched && lastName.invalid"
            required />
          <div
            *ngIf="lastName.touched && lastName.invalid"
            class="c-form-alert">
            {{ "user.lastnamerequirederror" | translate }}
          </div>
        </div>
        <div class="c-form-group o-grid__item col-12">
          <label
            for="email"
            class="c-form-label"
            >{{ "user.email" | translate }}</label
          >
          <input
            #email="ngModel"
            [(ngModel)]="user.email"
            name="email"
            id="email"
            type="email"
            [ngClass]="
              isNewUser
                ? 'c-input c-input--alpha'
                : 'c-input c-input--alpha c-not-allowed c-user-readonly'
            "
            [class.is-invalid]="(email.touched && email.invalid) || userAlreadyExists"
            (ngModelChange)="userAlreadyExists = false"
            email
            required
            [readonly]="!isNewUser" />
          <div
            *ngIf="email.touched && email.errors?.required"
            class="c-form-alert">
            {{ "user.emailrequirederror" | translate }}
          </div>
          <div
            *ngIf="email.touched && email.errors?.email"
            class="c-form-alert">
            {{ "user.emailinvaliderror" | translate }}
          </div>
          <div
            *ngIf="userAlreadyExists"
            class="c-form-alert">
            {{ "user.emailtakenerror" | translate }}
          </div>
        </div>
        <div class="c-form-group o-grid__item col-12">
          <label
            for="phoneNumber"
            class="c-form-label"
            >{{ "user.phone" | translate
            }}<span class="c-postfix"> ({{ "user.labeloptional" | translate }})</span></label
          >
          <input
            #phoneNumber="ngModel"
            [(ngModel)]="user.phoneNumber"
            name="phoneNumber"
            id="phoneNumber"
            type="tel"
            class="c-input c-input--alpha"
            [class.is-invalid]="phoneNumber.touched && phoneNumber.invalid" />
          <div
            *ngIf="phoneNumber.touched && phoneNumber.invalid"
            class="c-form-alert">
            {{ "user.phonerequirederror" | translate }}
          </div>
        </div>
        <div class="c-form-group o-grid__item col-12">
          <label
            class="c-form-label"
            for="role"
            >{{ "user.role" | translate }}</label
          >
          <mat-select
            #role="ngModel"
            [(ngModel)]="user.role"
            name="role"
            id="role"
            class="c-user-menu__select c-select c-select--lg"
            (ngModelChange)="onRoleChange()"
            [class.is-invalid]="role.touched && role.invalid"
            required>
            <mat-option
              *ngFor="let r of roles"
              [value]="r">
              {{ r }}
            </mat-option>
          </mat-select>
          <div
            *ngIf="role.touched && role.invalid"
            class="c-form-alert">
            {{ "user.rolerequirederror" | translate }}
          </div>
        </div>
        <ng-container *ngIf="user.isCountryGroupProfile">
          <div class="c-form-group o-grid__item col-9">
            <label
              class="c-form-label"
              for="famcode"
              >{{ "user.famcode" | translate }}</label
            >
            <mat-select
              #famcode="ngModel"
              ngModel
              name="famcode"
              id="famcode"
              class="c-user-menu__select c-select c-select--lg"
              [class.is-invalid]="noFams">
              <mat-option value="">{{ "user.selectfamcode" | translate }}</mat-option>
              <mat-option
                *ngFor="let fam of famCodes | sortBy: 'asc'"
                [value]="fam">
                {{ fam }}
              </mat-option>
            </mat-select>
            <div
              *ngIf="noFams"
              class="c-form-alert">
              {{ "user.famcoderequirederror" | translate }}
            </div>
          </div>
          <div class="c-form-group o-grid__item col-3">
            <label class="c-form-label">&nbsp;</label>
            <button
              type="button"
              class="button button-secondary button-block"
              [disabled]="!famcode.value"
              (click)="addFam(famcode.value)">
              {{ "button.add" | translate }}
            </button>
          </div>
          <div
            *ngFor="let f of user.famcodes"
            class="c-form-group o-grid__item col-4 col-sm-3">
            <div class="c-form-chip">
              <span class="c-form-chip__text">{{ f }}</span>
              <fa-icon
                class="c-form-chip__close u-ml--medium end"
                [icon]="faClose"
                (click)="removeFam(f)"></fa-icon>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div
    *ngIf="user && pendingUser"
    class="row center bg-default-sm u-shadow">
    <div class="col u-mw--600 start">
      <div class="o-grid--medium">
        <div class="o-grid__item col">
          <div class="c-card">
            <div class="c-card__title">
              {{ "user.pendinguserinfo" | translate }}
            </div>
            <div class="c-card__description">
              <div class="c-card__description">{{ requestedCompany }}</div>
            </div>
            <div class="c-card__description">
              <div>
                <pre class="c-card__description">{{ user?.address }}</pre>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="user"
    class="row center bg-white bg-default-sm u-shadow">
    <div class="c-user col u-mw--600">
      <div class="o-grid--medium">
        <h2 class="o-grid__item col-12 u-text-left">
          {{ localizationConstants.USER_PLANNING_BOARD_ROLE | translate }}
        </h2>
      </div>
      <div class="c-form-group o-grid__item col-12">
        <mat-select
          #pbRole="ngModel"
          [(ngModel)]="user.planningBoardRole"
          name="pbRole"
          id="pbRole"
          class="c-user-menu__select c-select c-select--lg"
          [compareWith]="compareWithFnPbRoles"
          (ngModelChange)="onPbRoleChange()">
          <mat-option
            *ngFor="let r of planningBoardRoles"
            [value]="r">
            {{ r.pbRole }}
          </mat-option>
        </mat-select>
      </div>
    </div>
  </div>

  <div
    *ngIf="user"
    class="row center bg-white bg-default-sm u-shadow">
    <div class="c-user col u-mw--600">
      <div class="o-grid--medium">
        <h2 class="o-grid__item col-12 u-text-left">
          {{ "user.additionalApplicationsTitle" | translate }}
        </h2>

        <div class="o-grid__item col-12 u-b-divider--dark"></div>
        <div class="o-grid__item col-9 u-mt--medium">
          <div class="c-item-title">{{ "application.fs" | translate }}</div>
        </div>
        <div class="c-form-group o-grid__item col-3 u-mt--medium">
          <input
            #fsUser="ngModel"
            type="checkbox"
            name="fsUser"
            id="fsUserSlider"
            class="c-checkbox-slider--sm"
            (ngModelChange)="toggleFieldService($event)"
            [ngModel]="user.isFieldServiceUser" />
          <label
            for="fsUserSlider"
            class="c-switch-slider--sm"></label>
        </div>

        <div class="o-grid__item col-12 u-b-divider--dark"></div>
        <div class="o-grid__item col-9 u-mt--medium">
          <div class="c-item-title">{{ "application.ea" | translate }}</div>
        </div>
        <div class="c-form-group o-grid__item col-3 u-mt--medium">
          <input
            #eaUser="ngModel"
            type="checkbox"
            name="eaUser"
            id="eaUserSlider"
            class="c-checkbox-slider--sm"
            [class.is-invalid]="user.isFieldServiceUser"
            [disabled]="user.isFieldServiceUser"
            [readonly]="user.isFieldServiceUser"
            [(ngModel)]="user.isEquipmentAdministrationUser" />
          <label
            [ngClass]="user.isFieldServiceUser ? 'c-not-allowed' : ''"
            for="eaUserSlider"
            class="c-switch-slider--sm"></label>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="user?.isUserGroupProfile"
    class="row center bg-white bg-default-sm u-shadow">
    <div class="c-user col u-mw--600">
      <div class="o-grid--medium">
        <h2 class="o-grid__item col-12 u-text-left">
          {{ "user.companies" | translate }}
        </h2>
        <div class="c-form-group o-grid__item col-9">
          <company-list
            [valid]="!noCompanies"
            class="is-invalid"
            (selectionChange)="selectedCompany = $event"
            required>
          </company-list>
          <div
            *ngIf="noCompanies"
            class="c-form-alert">
            {{ "user.companyrequirederror" | translate }}
          </div>
        </div>
        <div class="c-form-group o-grid__item col-3">
          <button
            type="button"
            class="button button-secondary button-block"
            [disabled]="!selectedCompany || isAddingCompany"
            (click)="addCompany(selectedCompany)">
            <span *ngIf="!isAddingCompany">{{ "button.add" | translate }}</span>
            <app-loading-icon *ngIf="isAddingCompany"></app-loading-icon>
          </button>
        </div>
        <ng-container *ngFor="let c of user.companies">
          <div class="o-grid__item col-12 u-b-divider--dark"></div>
          <div class="c-form-group o-grid__item col-9 u-mt--medium">
            <div class="u-text-left u-font-size-18 u-line-height-34">
              {{ c.fullName + ", " + c.name }}
            </div>
          </div>
          <div class="c-form-group o-grid__item col-3 u-mt--medium">
            <button
              (click)="removeCompany(c)"
              class="button--sm button-secondary button-block">
              {{ "button.remove" | translate }}
            </button>
          </div>
          <ng-container *ngIf="c.departmentList && c.departmentList.length > 0">
            <div class="c-form-group o-grid__item col">
              <label
                class="c-form-label"
                for="department"
                >{{ "user.departments" | translate }}:</label
              >
              <department-select [company]="c"></department-select>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
  <div
    *ngIf="reminderSubscriptions"
    class="row center bg-white bg-default-sm u-shadow">
    <div class="c-user col u-mw--600">
      <div class="o-grid--medium">
        <h2 class="o-grid__item col-12 u-text-left">
          {{ "user.internalsubscriptioncopies" | translate }}
        </h2>
        <ng-container *ngFor="let r of reminderSubscriptions">
          <div class="o-grid__item col-12 u-b-divider--dark"></div>
          <div class="o-grid__item col-9 u-mt--medium">
            <div class="c-item-title">{{ r.title | translate }}</div>
          </div>
          <div class="c-form-group o-grid__item col-3 u-mt--medium">
            <input
              type="checkbox"
              [name]="r.key + 'Slider'"
              [id]="r.key + 'Slider'"
              class="c-checkbox-slider--sm"
              [(ngModel)]="r.selected" />
            <label
              [for]="r.key + 'Slider'"
              class="c-switch-slider--sm"></label>
          </div>
          <div
            *ngIf="r.selected"
            class="c-form-group o-grid__item col-12">
            <input
              [id]="r.key"
              [(ngModel)]="r.email"
              [name]="r.key?.toString()"
              type="text"
              class="c-input c-input--alpha"
              [disabled]="!r.selected" />
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div
    *ngIf="userSubscriptions"
    class="row center bg-white bg-default-sm u-shadow">
    <div class="c-user col u-mw--600">
      <div class="o-grid--medium">
        <h2 class="o-grid__item col-12 u-text-left">
          {{ "user.subscriptions" | translate }}
        </h2>
        <ng-container *ngFor="let s of userSubscriptions | sortBy: 'desc' : 'isActive'">
          <user-subscription
            [subscription]="s"
            class="o-grid__item col-12"></user-subscription>
        </ng-container>
      </div>
    </div>
  </div>
  <div
    *ngIf="user?.isUserGroupProfile"
    class="row center bg-white bg-default-sm u-shadow">
    <div class="c-user col u-mw--600">
      <div class="o-grid--medium">
        <h2 class="o-grid__item col-12 u-text-left">
          {{ "user.vendors" | translate }}
        </h2>
        <div class="c-form-group o-grid__item col-9">
          <wimt-select
            [items]="vendorList"
            placeholder="{{ 'user.selectvendor' | translate }}"
            (valueChange)="selectedVendor = $event">
          </wimt-select>
        </div>
        <div class="c-form-group o-grid__item col-3">
          <button
            type="button"
            class="button button-secondary button-block"
            [disabled]="!selectedVendor"
            (click)="addVendor(selectedVendor)">
            <span>{{ "button.add" | translate }}</span>
          </button>
        </div>
        <ng-container *ngFor="let v of user.userVendors">
          <div class="o-grid__item col-12 u-b-divider--dark"></div>
          <div
            class="o-grid__item col-10 u-mt--medium c-clickable"
            (click)="setVendorAsDefault(v)">
            <div class="c-item-title">
              <span>{{ v.vendorName }}</span>
              <span
                *ngIf="v.isDefault"
                class="c-postfix">
                ({{ "user.default" | translate }})</span
              >
            </div>
          </div>
          <div class="c-form-group o-grid__item col-2 u-mt--medium">
            <button
              (click)="removeVendor(v.vendorName)"
              class="button--sm button-secondary button-block">
              {{ "button.remove" | translate }}
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div
    *ngIf="user"
    class="row center bg-white bg-default-sm u-shadow c-user-save">
    <div class="col u-mw--600">
      <button
        type="button"
        class="button button-primary button-block"
        (click)="save()"
        [disabled]="
          userForm.invalid || isSaving || isLoading || userAlreadyExists || isMissingFromEntra
        ">
        <app-loading-icon *ngIf="isSaving || isLoading"></app-loading-icon>
        <span *ngIf="!isSaving && !isLoading">{{ "button.save" | translate }}</span>
      </button>
    </div>
  </div>
</form>

<!-- <div class="row">
  <div class="col">
    <textarea style="min-width: 100%; max-width: 100%; min-height: 60vh; max-height: 60vh;" disabled>{{ userSubscriptions | json }}</textarea>
  </div>
</div> -->
